var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:{bordered: _vm.border},staticStyle:{"position":"relative"}},[_vm._t("default"),_c('div',{staticClass:"fe-chart-toolbar d-flex"},[_vm._t("tools")],2)],2)}
var staticRenderFns = []

export { render, staticRenderFns }